"use client"

import { useEffect, useState } from "react"

export function useScrollYThreshold(threshold: number = 10): boolean {
  const [isPastThreshold, setIsPastThreshold] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)

    const handleScroll = () => {
      setIsPastThreshold(window.scrollY > threshold)
      //console.log("🚀 ~ handleScroll ~ window.scrollY:", window.scrollY)
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll() // 초기 상태 설정

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [threshold])

  // 하이드레이션 완료 전까지는 항상 false 반환
  return mounted ? isPastThreshold : false
}
